import { useEffect, useRef, useState } from "react"
import { Button, Form, FormGroup, Label } from "reactstrap"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import ThemeModal from "components/Common/ThemeModal"

const toIsoDate = date => {
  if (!date) return ""
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, "0")
  const dd = String(date.getDate()).padStart(2, "0")
  return `${yyyy}-${mm}-${dd}`
}

const parseIsoDate = iso => {
  if (!iso) return null
  const parts = String(iso).split("-")
  if (parts.length !== 3) return null
  const [y, m, d] = parts.map(Number)
  if (!y || !m || !d) return null
  return new Date(y, m - 1, d)
}

const normalizeIsoDate = value => {
  if (!value) return ""
  const str = String(value)
  const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (match) return `${match[1]}-${match[2]}-${match[3]}`
  const parsed = new Date(str)
  if (Number.isNaN(parsed.getTime())) return ""
  return toIsoDate(parsed)
}

const PrintDateModal = ({
  isOpen,
  toggle,
  onSubmit,
  isSubmitting = false,
  title = "Print Date",
  defaultDate = "",
}) => {
  const [printDate, setPrintDate] = useState("")
  const touchedRef = useRef(false)

  useEffect(() => {
    if (isOpen && !touchedRef.current) {
      setPrintDate(normalizeIsoDate(defaultDate))
    }
  }, [isOpen, defaultDate])

  const handleDateChange = date => {
    touchedRef.current = true
    setPrintDate(toIsoDate(date))
  }

  const handleSubmit = event => {
    event.preventDefault()
    onSubmit(printDate)
  }

  return (
    <ThemeModal
      isOpen={isOpen}
      toggle={toggle}
      title={title}
      size="md"
      footer={
        <div className="d-flex justify-content-end gap-2 w-100">
          <Button color="light" onClick={toggle} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? "Generating..." : "Generate PDF"}
          </Button>
        </div>
      }
    >
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="print_date" className="fw-semibold">
            Print Date
          </Label>
          <DatePicker
            id="print_date"
            selected={parseIsoDate(printDate)}
            onChange={handleDateChange}
            dateFormat="MMMM d, yyyy"
            placeholderText="Select date"
            className="form-control"
            isClearable
            disabled={isSubmitting}
            autoComplete="off"
            wrapperClassName="d-block"
          />
          <small className="text-muted">
            Clear the field to print without a date.
          </small>
        </FormGroup>
      </Form>
    </ThemeModal>
  )
}

export default PrintDateModal
